import { createAction, props } from '@ngrx/store';
import { ITradeComment, ITradeCommentSubmit } from '@shared/models';

export enum ActionTypes {
  Load              = '[Feed] Load',
  LoadSuccess       = '[Feed] Load Success',
  Clear             = '[Feed] Clear',
  AddComment        = '[Feed] Add Comment'
}

export const load = createAction(
  ActionTypes.Load
);

export const loadSuccess = createAction(
  ActionTypes.LoadSuccess,
  props<{ tradeFeed: ITradeComment[] }>()
);

export const clear = createAction(
  ActionTypes.Clear
);

export const addComment = createAction(
  ActionTypes.AddComment,
  props<{ comment: ITradeCommentSubmit }>()
);



